(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    var header=document.querySelector('.pckey-v66-header');
    var toggle=document.querySelector('[data-menu-toggle]');
    var nav=document.querySelector('[data-mobile-nav]');
    if(header && toggle && nav){
      toggle.addEventListener('click',function(e){
        e.preventDefault();
        var open=header.classList.toggle('is-menu-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('pckey-menu-open', open);
      });
      nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){header.classList.remove('is-menu-open');toggle.setAttribute('aria-expanded','false');document.documentElement.classList.remove('pckey-menu-open');});});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'){header.classList.remove('is-menu-open');toggle.setAttribute('aria-expanded','false');document.documentElement.classList.remove('pckey-menu-open');}});
    }
    document.querySelectorAll('[data-dropdown-toggle]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        if(window.matchMedia('(max-width: 990px)').matches){
          e.preventDefault();
          var item=btn.closest('[data-dropdown]');
          if(!item) return;
          var isOpen=item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen?'true':'false');
        }
      });
    });
    // Prevent native search cancel from visually appearing in some webkit builds by normalizing value repaint.
    document.querySelectorAll('.pckey-v66-search input[type="search"]').forEach(function(input){
      input.setAttribute('placeholder','');
      input.addEventListener('input',function(){ input.style.backgroundColor='#fffaf0'; input.style.color='#061320'; });
      input.addEventListener('focus',function(){ input.style.backgroundColor='#fffaf0'; input.style.color='#061320'; });
    });
  });
})();
